import React from 'react';

// Settings written as sentences, in a card: each row has a small capitals label on the left and its sentence on the
// right, with the choices inline (InlineSelect). rows are { label, content, note }, the note a small line under the
// sentence. children go in the card's foot, under a dashed line: a timeline of what the settings do, for example.
export default function SettingRows({ rows = [], children = null }) {
  return (
    <div className='setrow-card'>
      <div className='setrow-list'>
        {rows.map((row) => (
          <div
            key={row.label}
            className='setrow'
          >
            <span className='setrow-label'>{row.label}</span>
            <div className='setrow-text'>
              {row.content}
              {row.note && <div className='setrow-note'>{row.note}</div>}
            </div>
          </div>
        ))}
      </div>
      {children && <div className='setrow-foot'>{children}</div>}
    </div>
  );
}
